import produce from 'immer';
import { GET_PERSONAL_INFO } from '@profile-ui-mono/utilities/queries';
/**
 * @param {Object} cache
 * @param {String} userId
 * @returns {Object}
 * @description Returns the cached data for the current user
 * @example
 * const { data } = useQuery(GET_PERSONAL_INFO, {
 *  variables: { id: userId },
 * fetchPolicy: 'cache-first',
 * });
 * const { personalInfo, profileImages } = getCachedData(cache, userId);
 */
export function getCachedData(cache, userId) {
  return cache.readQuery({
    query: GET_PERSONAL_INFO,
    variables: {
      filter: { id: userId },
    },
  });
}

/**
 * @param {Object} cache
 * @param {String} userId
 * @param {function} writeCacheFn
 * @description Updates the cache with the new data
 * @example
 * updateDataCache(cache, userId, (draft) => {
 * draft.personalInfo.basicInfo.firstName = 'Test';
 * draft.personalInfo.basicInfo.lastName = 'Test';
 * draft.personalInfo.basicInfo.screenName = 'Test';
 * });
 *
 * @returns {void}
 */
export function updateDataCache(cache, userId, writeCacheFn) {
  cache.writeQuery({
    query: GET_PERSONAL_INFO,
    variables: {
      filter: { id: userId },
    },
    data: produce(getCachedData(cache, userId), writeCacheFn),
  });
}
